export default {
  ValorParaAlto: 'fields.engineering.cooling-efficiency.value-to-high',
  ValorParaMuitoAlto: 'fields.engineering.cooling-efficiency.value-to-very-high',
  TemporizacaoEmissaoDiagnosticoDiferencaMaximaAdmissivelUltrapassada: 'fields.engineering.cooling-efficiency.timing-diagnostic-emission-exceeded-maximum-allowable-difference',
  VolumeOleo: 'fields.asset.transformer.oil-volume',
  MassaOleoQuilos: 'fields.asset.transformer.oil-mass',
  MassaTanque: 'fields.asset.transformer.tank-mass-and-accessories',
  MassaParteAtiva: 'fields.asset.transformer.mass-active-part',
  PesoTotal: 'fields.asset.transformer.total-weight',
};
